import { Injectable } from "@angular/core";
import { CanDeactivate } from "@angular/router";

import { GatewaysComponent } from "./gateways.component";

@Injectable()
export class PrivateGatewayDeactivateGuard implements CanDeactivate<GatewaysComponent> {

	public canDeactivate(component: GatewaysComponent): boolean {
		return component.confirmLeavePrivate();
	}
}
